export class SkillDomain {
    id: string;
    name: string;
    displayName: string;
}
